import { useEffect } from 'react';

import { selectUser } from '../slices/userSlice';

import { useAppSelector } from './index';

interface ZendeskOptions {
    name: {
        value: string;
    };
    email: {
        value: string;
    };
}

declare global {
    interface Window {
        zE: (widget: string, prefill: string, options?: ZendeskOptions) => void;
    }
}

const useZendesk = () => {
    const user = useAppSelector(selectUser);



    const removeBrowserField = (webWidget: HTMLIFrameElement) => {
        if(webWidget){
            const iframeDoc = webWidget.contentDocument || webWidget.contentWindow?.document;

            if(iframeDoc){
                // Add styles
                const style = iframeDoc.createElement('style');
                style.textContent = `
                main[data-testid=scroll-container-content] > div > div:nth-of-type(3) { display: none; }
                `;
                iframeDoc.head.appendChild(style);
            }
        }
    }

    useEffect(() => {
        const observer = new MutationObserver((mutations, _) => {
            for (const m of mutations) {
                if (m.type === "childList") {
                    const added = m.addedNodes;
                    added.forEach(node => {
                        if(node.nodeType === Node.ELEMENT_NODE){
                            const _node = node as HTMLElement;
                            const id = _node.getAttribute("id");
                            if(id === 'webWidget'){ 
                                removeBrowserField(_node as HTMLIFrameElement)
                            }
                        }
                    })
                }
            }
        });

        observer.observe(document, { attributes: false, childList: true, subtree: true });

        return () => observer.disconnect();
    }, []);

    const activateZendesk = () => {
        window.zE('webWidget', 'prefill', {
            name: {
                value:
                    user.value?.first_name !== undefined
                        ? `${user.value?.first_name} ${user.value?.last_name}`
                        : '',
            },
            email: {
                value: user.value?.email !== undefined ? user.value?.email : '',
            },
        });

        window.zE('webWidget', 'show');
        window.zE('webWidget', 'open');

        const widget = document.getElementById('launcher');
        if (widget != null) {
            widget.style.display = 'none';
        }
    };

    return {
        activateZendesk,
    };
};

export default useZendesk;
